import { normalizeLocale } from "@/i18n/routing";

/** Base URL for this Next.js marketing / public-profile site. */
export function getLandingPageBaseUrl(): string {
  const explicit = process.env.NEXT_PUBLIC_LANDING_PAGE_URL?.trim();
  if (explicit) return explicit.replace(/\/+$/, "");

  const vercelUrl = process.env.VERCEL_URL?.trim();
  if (vercelUrl) return `https://${vercelUrl.replace(/\/+$/, "")}`;

  return "http://localhost:3001";
}

export function landingPageHomeHref(locale: string): string {
  const normalized = normalizeLocale(locale);
  return `${getLandingPageBaseUrl()}/${normalized}`;
}

export function landingPagePricingHref(locale: string): string {
  return `${landingPageHomeHref(locale)}/memberships/plans`;
}
